import { DownloadOutlined } from '@ant-design/icons'
import { Space } from 'antd'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { URLBuilderWithCustomer } from 'app/lib/URLBuilder'
import React from 'react'

const DownloadButtons: React.FC = () => {
  const { tButtonTitle } = useTranslation({ recordType: RecordType.price_list })

  const pdfUrl = new URLBuilderWithCustomer().build('price_lists/price_list_pdf')
  const csvUrl = new URLBuilderWithCustomer().build('price_list.csv')

  return (
    <Space>
      <Button
        onClick={() => window.open(pdfUrl)}
        title={tButtonTitle({ id: 'download_pdf' })}
        type="secondary"
        icon={<DownloadOutlined />}
      />
      <Button
        onClick={() => window.open(csvUrl)}
        title={tButtonTitle({ id: 'download_csv' })}
        type="secondary"
        icon={<DownloadOutlined />}
      />
    </Space>
  )
}

export default DownloadButtons
